((GlobalFooter, $) => {
  'use strict';

  const $dom = {};

  const menuActiveClass = 'js-menu-is-active';

  const cacheDom = () => {
    $dom.footerMenuToggle = $('.site-footer--menu-column--menu-title');
  };

  const bindUIActions = () => {
    $dom.footerMenuToggle.on('click', function(event) {
      let $menu = $(this).parent('.site-footer--menu-column');
      // Toggle Clicked Menu
      $menu.hasClass(menuActiveClass) ?  $menu.removeClass(menuActiveClass) : $menu.addClass(menuActiveClass);
      // Close All Other Menus
      $menu.siblings().removeClass(menuActiveClass);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  GlobalFooter.init = init;

})(window.GlobalFooter = window.GlobalFooter || {}, jQuery);
